export const DEFAULT_COLOR_PROFILE = "sRGB IEC61966-2.1";

// Width and height are required canvas dimensions
export const sizeRules = [
  { required: true, message: "Bắt buộc" },
  { type: "number", min: 0.01, message: "Phải lớn hơn 0" },
];
